import type { AxiosError, AxiosResponse, AxiosStatic, InternalAxiosRequestConfig } from 'axios';
import { API_BASE_URL, APP_ACCESS_TOKEN_KEY } from '@/utils/constants';

import { handleAppError } from '@/utils/errorHandler';

// let isRefreshing = false;
// const failedQueue: any[] = [];

/* const processQueue = (error: unknown, token: string | null = null) => {
  failedQueue.forEach((promise) => {
    if (error) {
      promise.reject(error);
    } else {
      promise.resolve(token);
    }
  });

  failedQueue = [];
};*/

export default function interceptors(axios: AxiosStatic) {
  axios.defaults.baseURL = API_BASE_URL;
  axios.interceptors.request.use(
    (config) => {
      const accessToken = localStorage.getItem(APP_ACCESS_TOKEN_KEY);
      if (accessToken && config.headers) {
        config.headers.authorization = `Bearer ${accessToken}`;
      }
      return config;
    },

    (error: AxiosError) => {
      return Promise.reject(error);
    },
  );

  axios.interceptors.response.use(
    (response: AxiosResponse) => response.data,
    async (error: AxiosError) => {
      const originalConfig: InternalAxiosRequestConfig | undefined = error.config;
      handleAppError(error);

      console.error('API Error:', error);
      if (error.response) {
        if (error.response.status === 401) {
          if (originalConfig) {
            // refreshToken(originalConfig, axios); // enable if app's required refresh token
          } else {
            console.error('401 error received, but original config is undefined.', error);
          } // enable if app's required refresh token
        }

        return Promise.reject(error.response.data);
      }
      return Promise.reject(error);
    },
  );
}

/* const refreshToken = async (originalConfig: AxiosRequestConfig<any>, axios: AxiosStatic) => {
  if (isRefreshing) {
    return new Promise((resolve, reject) => {
      failedQueue.push({ resolve, reject });
    });
  }

  isRefreshing = true;

  try {
    const accessToken = ''; // fetch new token here and push new token for accessToken variable

    if (originalConfig?.headers) {
      originalConfig.headers.authorization = `Bearer ${accessToken}`;
    }

    processQueue(null, accessToken);

    return axios(originalConfig);
  } catch (error) {
    processQueue(error, null);
    return Promise.reject(error);
  } finally {
    isRefreshing = false;
  }
};*/
